import tableCardList from './view/page/tableAdmin/tableAdmin.vue' //桌位管理
import categoryList from './view/page/classify/classify.vue' //分类管理
import goodsList from './view/page/commodityAdmin/commodityAdmin.vue' //菜品管理
import operationLogList from './view/page/logSearch/logSearch.vue' //日志查询
import orderList from './view/page/orderAdmin/orderAdmin.vue' //订单管理
import statistic from './view/page/sellCount/sellCount.vue' //销售统计
import editPw from './view/page/editPw/editPw.vue' //修改密码
import Account from './view/page/Account/Account.vue'  //账户管理
import editphone from './view/page/editphone/editphone.vue'  //修改手机号
import businessStatusList from './view/page/operatingState/operatingState.vue' //桌位状态
import exportFile from "./components/exportFile"; //导出文件
import qrcode from './view/page/qrcode/qrcode.vue' //二维码
export default {
  exportFile,
  editPw,
  Account,
  editphone,
  businessStatusList,
  statistic,
  orderList,
  operationLogList,
  goodsList,
  categoryList,
  tableCardList,
  qrcode
}



// WEBPACK FOOTER //
// ./src/view.js